import * as React from "react";
import { Box, makeStyles } from "@material-ui/core";
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";

import { Source } from "services/valuation/types";
import { Theme } from "theme";

import SourceBreakdownChartCustomTooltip from "./SourceBreakdownChartCustomTooltip";

const useStyles = makeStyles<Theme, { pieChartHeight: number }>({
  chartContainer: {
    maxWidth: 500,
    height: props => props.pieChartHeight || 500,
    position: "relative",
    bottom: 15,
    right: 5,
  },
});

interface SourceBreakdownChartProps {
  colors: string[];
  sources: Source[];
  totalValue: number;
  pieChartHeight: number;
}

const SourceBreakdownChart: React.FC<SourceBreakdownChartProps> = ({
  colors,
  sources,
  totalValue,
  pieChartHeight,
}) => {
  const classes = useStyles({ pieChartHeight });

  return (
    <Box className={classes.chartContainer}>
      <ResponsiveContainer>
        <PieChart>
          <Tooltip
            content={
              <SourceBreakdownChartCustomTooltip
                totalValue={totalValue}
                sources={sources}
              />
            }
          />
          <Pie
            data={sources}
            paddingAngle={1}
            dataKey="earnings"
            nameKey="name"
            outerRadius="80%"
            innerRadius="55%"
            isAnimationActive={false}
          >
            {sources.map((_, index) => (
              <Cell
                key={`cell-${index}`}
                fill={colors[index % colors.length]}
              />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default SourceBreakdownChart;
